import React from 'react';
import { Input } from 'antd';
import FormItem from '../FormItem/FormItem';

const InputField = ({
  form,
  label,
  name,
  decoratorOptions,
  fieldProps = {},
  formItemProps = {},
}) => {
  const { getFieldDecorator } = form;

  return (
    <FormItem
      label={label}
      {...formItemProps}
    >
      {getFieldDecorator(name, decoratorOptions)(<Input {...fieldProps} />)}
    </FormItem>
  );
};

export default InputField;
